import React from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import { FaMapMarkerAlt, FaHotel, FaUtensils, FaCheckCircle, FaChevronRight, FaInfoCircle } from "react-icons/fa";

const TourDetails = ({ packages }) => {
  const itinerary = packages?.itinerary || [];
console.log("asdsadsadsad",packages ,itinerary);
const forfitImages =
  packages?.forfit
    ?.flatMap(f => Array.isArray(f.vehicleImage) ? f.vehicleImage : [])
    ?.filter(Boolean) || [];

  return (
    <Container className="my-5 py-4">
      
      {/* Section Title */}
      <div className="mb-5 ps-4"
      style={{
        borderLeft: "4px solid #0a3b78",
      }}
      >
        <h2 className="fw-bold mb-1" style={{
          color:"#0a3b78"
        }}>Hotels of Your Tours</h2>
        <p className="text-muted mb-0">Best facilities with no added cost throughout your journey.</p>
      </div>

      <Row>
        <Col lg={10} className="mx-auto">
          <div className="timeline-wrapper position-relative">
            {/* Main Timeline Line */}
            <div className="timeline-line"></div>

      {itinerary.map((item, index) => {
  const isDeparture = item.title.toLowerCase().includes("departure");
  const isLast = index === itinerary.length - 1; // check if it's the last item

  return (
    <div key={item.id} className="timeline-item mb-3 position-relative ps-5">
      {/* Timeline Dot */}
{
!isLast &&
      <>
      <div className="timeline-dot shadow-sm">{item.day}</div>

      {/* Timeline Line */}
      {!isLast && <div className="timeline-line"></div>} {/* hide line for last item */}

      {/* Card */}
      <div className="hotel-content-card shadow-sm border rounded-3 bg-white p-3">
        <Row className="align-items-start">
          <Col md={8}>
            <div className="d-flex align-items-center mb-2">
              <span className="location-badge me-3">
                <FaMapMarkerAlt className="me-1" /> {item.accommodation}
              </span>
            </div>
            <h5 className="fw-bold text-dark mb-2">
              {isDeparture ? "Journey Ends / Departure" : (item.hotalName || item.accommodation)}
            </h5>
            <div className="d-flex flex-wrap gap-2 mb-2">
              {item.activities?.map((act, i) => (
                <span key={i} className="activity-chip">
                  <FaChevronRight size={8} className="me-1" /> {act}
                </span>
              ))}
            </div>
          </Col>
          <Col md={4} className="border-start-md ps-md-4">
            <div className="meal-section">
              <h6 className="small fw-bold text-uppercase text-muted mb-2" style={{ letterSpacing: '1px' }}>
                Included Meals
              </h6>
              <div className="d-flex flex-wrap gap-2">
                {item.meals?.map((meal, mIdx) => (
                  <div 
                    key={mIdx} 
                    className="d-flex align-items-center small text-dark fw-medium" 
                    style={{ width: '48%' }}
                  >
                    <div className="meal-icon-box me-2">
                      <FaUtensils size={10} />
                    </div>
                    {meal}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      </>
}
    </div>
  );
})}

          </div>

          {/* Note Section */}
          <div className="mt-5 p-4 bg-light rounded-3 border d-flex align-items-start">
            <FaInfoCircle className="text-primary mt-1 me-3" size={20} />
            <p className="mb-0 small text-muted" style={{ lineHeight: '1.6' }}>
              <strong>Important Note:</strong> Under unavoidable circumstances, hotels are subject to change. 
              In such cases, a substitute hotel of similar category will be provided to ensure your comfort level is maintained.
            </p>
          </div>
        </Col>
      </Row>

      <style dangerouslySetInnerHTML={{ __html: `
        .timeline-wrapper { padding-top: 10px; }
        
        .timeline-line {
          position: absolute;
          left: 17px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #e2e8f0;
          z-index: 1;
        }

        .timeline-dot {
          position: absolute;
          left: 0;
          top: 0;
          width: 36px;
          height: 36px;
          background: #0a3b78;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          z-index: 2;
          border: 4px solid #fff;
        }

        .hotel-content-card {
          transition: all 0.3s ease;
        }
        
        .hotel-content-card:hover {
          border-color: #0a3b78 !important;
          transform: translateY(-2px);
        }

        .location-badge {
          background: #f1f5f9;
          padding: 4px 12px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 700;
          color: #475569;
          text-transform: uppercase;
        }

        .activity-chip {
          font-size: 10px;
          padding: 3px 10px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 4px;
          color: #64748b;
        }

        .meal-icon-box {
          width: 22px;
          height: 22px;
          background: #ebf5ff;
          color: #007bff;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media (min-width: 768px) {
          .border-start-md { border-left: 1px solid #f1f5f9 !important; }
        }

        .timeline-item:last-child .timeline-line {
          display: none;
        }
      `}} />
    </Container>
  );
};

export default TourDetails;


